<template>
  <div>
  <router-link to="/plan/bonus" class="back-link">
    <Flexy><img :src="ArrowRightIcon" /> <p>{{t('Discount for supplements')}}</p></Flexy>
  </router-link>
  <div class="container-m coupon-codes">
    <h4>{{t("coupon-code-title")}}</h4>
    <b>{{t("coupon-code", couponCode)}}</b>
    <small>{{t("coupon-code-content")}}</small>
    <p><a class="btn" :href="couponLink" target="_blank">{{t("coupon-code-link")}}</a></p>
  </div>
  </div>
</template>

<script>

import t from '@/lib/Locale';
import ArrowRightIcon from '@/assets/icons/arrow-right.svg';
import Flexy from "@/components/ui/widgets/Flexy.vue";
export default {
  name: "CouponCodes",
  components: {Flexy},
  data() {
    return {
      ArrowRightIcon,
      couponCode: "BH7H9",
      couponLink: "https://rambam-medicine.org.il/shop/product-category/supplements/"
    }
  },
  mounted() {
  },
  methods: {
    t,
  }
}

</script>